import { render, staticRenderFns } from "./MixedKeyboard.vue?vue&type=template&id=556c9c08&scoped=true&"
import script from "./MixedKeyboard.vue?vue&type=script&lang=js&"
export * from "./MixedKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./MixedKeyboard.vue?vue&type=style&index=0&id=556c9c08&prod&lang=css&"
import style1 from "./MixedKeyboard.vue?vue&type=style&index=1&id=556c9c08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c9c08",
  null
  
)

export default component.exports